<div class="customers-pane" [class.resized]="searchBarVisible || isResized">
  <div
    class="resize-handle"
    data-testid="customers-pane-resize-handle"
    *ngIf="!!selectedTab"
    (mousedown)="onCustomersPaneMouseDown($event)"
    (touchstart)="onCustomersPaneMouseDown($event)"
    (swipeup)="onCustomersPaneSwipeUp($event)"
    (swipedown)="onCustomersPaneSwipeDown($event)"
  >
    <div class="resize-handle-icon"></div>
  </div>
  <div class="customers-pane-content">
    <header>
      <ul class="tabs">
        <li>
          <button
            class="tab-button"
            (click)="handleTabSelection('contacts')"
            [class.selected]="selectedTab === 'contacts'"
          >
            <span class="tab-button-text">{{ 'MY_CUSTOMERS' | translate | capitalizeFirstLetter }}</span>
          </button>
        </li>
        <li>
          <button
            class="tab-button"
            (click)="handleTabSelection('accounts')"
            [class.selected]="selectedTab === 'accounts'"
          >
            <span class="tab-button-text">{{ 'ACCOUNT_MY_ACCOUNTS' | translate }}</span>
          </button>
        </li>
      </ul>
      <ul class="actions">
        <li *ngIf="!!selectedTab">
          <ion-button
            fill="clear"
            size="small"
            (click)="handleAction($event, 'filter')"
            [disabled]="!selectedTab"
          >
            <ion-icon
              slot="icon-only"
              src="assets/imgs/header_filter.svg"
              class="filter-icon"
            ></ion-icon>
            <ion-badge color="primary" *ngIf="filterCount > 0">{{filterCount}}</ion-badge>
          </ion-button>
        </li>
        <li>
          <ion-button
            fill="clear"
            size="small"
            (click)="handleSearchBarButtonClick()"
            [class.selected]="!!searchBarVisible"
          >
            <ion-icon
              slot="icon-only"
              src="assets/imgs/search-icon.svg"
              class="search-icon"
            ></ion-icon>
          </ion-button>
        </li>
        <li hidden>
          <ion-button
            fill="clear"
            size="small"
            (click)="handleAction($event, 'tags')"
            [disabled]="!hasSelection || !selectedTab"
          >
            <ion-icon
              slot="icon-only"
              src="assets/imgs/tag-icon.svg"
              class="tag-icon"
            ></ion-icon>
          </ion-button>
        </li>
        <li *ngIf="!!selectedTab">
          <ion-button
            fill="clear"
            size="small"
            (click)="showMorePopover.present($event)"
            [disabled]="!selectedTab"
          >
            <ion-icon slot="icon-only" name="ellipsis-horizontal"></ion-icon>
          </ion-button>
          <ion-popover side="left" focusTrap="true" #showMorePopover>
            <ng-template>
              <ion-list>
                <ion-item
                  (click)="
                    handleAction($event, 'columns'); showMorePopover.dismiss()
                  "
                >
                  Edit Columns
                </ion-item>
              </ion-list>
            </ng-template>
          </ion-popover>
        </li>
      </ul>
    </header>
    <ion-searchbar
      *ngIf="!!searchBarVisible"
      (ionInput)="onSearch($event)"
      debounce="300"
      [value]="searchText"
      autoFocusSearchbar
      class="home-screen-searchbar"
      clear-icon="close-outline"
    ></ion-searchbar>
    <div
      class="content"
      #content
      [style.height]="contentHeight + 'vh'"
      *ngIf="!!selectedTab"
    >
      <contacts-table
        *ngIf="selectedTab === 'contacts'"
        #contactsTable
        [searchText]="searchText"
        (selectionChanged)="onSelectionChanged($event)"
        (filterChanged)="onFilterChanged($event)"
      ></contacts-table>
      <accounts-table
        *ngIf="selectedTab === 'accounts'"
        #accountsTable
        [searchText]="searchText"
        (selectionChanged)="onSelectionChanged($event)"
        (filterChanged)="onFilterChanged($event)"
      ></accounts-table>
    </div>
  </div>
</div>
